<div class="metric-card" [ngStyle]="cardStyle" [class.ledger]="type === 'ledger'">
  <div class="metric-card__title" [ngStyle]="titleStyle">
    {{ title }}
  </div>

  <div class="metric-card__value olv-figure">
    @if (!loading && value !== undefined) {
      <span>
        @if(+value | splitParts: baseCurrencyDisplayPrecision : baseCurrency; as parts) {
          <span class="integer">{{ parts.integer }}</span>
          @if(parts.decimal) {
            <span class="decimal">{{ parts.decimal }}</span>
            } }
          </span>
        }

        @if (!loading && value === undefined) {
          <span> - </span>
        }
      </div>
    </div>
